import { Components, Theme } from '@mui/material'

export const MuiAppBar: Components<Omit<Theme, 'components'>>['MuiAppBar'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      border: 0,
      borderBottom: '1px solid',
      borderBottomColor: 'rgba(0,0,0,0.12)',
      borderRadius: '0 !important',
      boxShadow: 'none',
      backgroundColor: '#F1F2F5',
      color: theme.palette.header.text,
      height: theme.mixins.toolbar.height,
      justifyContent: 'center',
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('md')]: {
        paddingLeft: '30px',
        paddingRight: 0,
      },
    }),
  },
}
